/** @jsxImportSource theme-ui */
import { unselectable } from "../../styles";
export default unselectable;
